var DialogView = require('dialogview');
var PastebinView = require('pastebinview');


var PastebinDialogView = DialogView.extend({
    el: '#pastebinContainer',
    initialize: function (options) {
        this.form = $('#pastebinForm');
        this.pastebinSelect = this.$('.pastebinSelect');
        this.pastebinWrapper = this.$('.pastebinWrapper');
        this.nameInput = $('#pastePreviewName');
        this.messageInput = $('#pastePreviewMessage');
        
        this.askContainer = $('#pasteConfirmAskContainer');
        this.askCheckbox = $('#pasteConfirmAsk');
        

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit #pastebinForm': 'submit',
        'buttonClick .sendAsText': 'clickSendAsText',
        'keydown': 'keyDown',
    }),
    init: function () {
        if (this.onCancel && (!this.confirmed || this.errored)) {
            this.onCancel();
        }
        this.onCancel = null;
        this.confirmed = null;
        this.errored = null;

        this.buffer = null;
        this.options = null;
        this.pbv = null;

        this.pastebinSelect.empty();
        this.pastebinWrapper.empty();
        this.nameInput.val('');
        this.messageInput.val('');
        this.enableForm();
    },
    keyDown: function (e) {
        if (e.shiftKey && e.keyCode == 13) { // shift+enter
            this.clickSendAsText(e);
        }
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    submit: function (e) {
        e.preventDefault();
        var data = this.form.serializeForm();
        this.disableForm();
        this.options.message = data.message;
        this.options.name = data.name;
        this.savePastebin(this.options, this.buffer);
    },
    clickSendAsText: function (e) {
        e.preventDefault();
        var focused = this.$(':focus');
        this.$el.hide();
        this.closed();
        this.buffer.say(this.pbv.editorContents(), {
            onConfirm: _.bind(function () {
                this.opened();
                this.done();
            }, this),
            onCancel: _.bind(function () {
                this.$el.show();
                this.opened();
                focused.focus();
            }, this) 
        });
    },
    done: function () {
        this.confirmed = true;
        this.hide();
    },
    savePastebin: function (options, buffer) {
        var pbv = this.pbv;
        pbv.save(options.name, _.bind(function (response) {
            if (response.success) {
                var msg = pbv.model.getUrl();
                if (options.message) {
                    msg = options.message + ' ' + msg;
                }
                buffer.say(msg);
            } else {
                this.errored = true;
                buffer.trigger('postError', response);
            }
            this.done();
        }, this));
    },
    makePaste: function () {
        var paste = {
            body: this.options.contents
        };
        if (this.options.file) {
            this.options.name = this.options.file.name;
            paste.name = this.options.file.name;
        }
        return PastebinView.fromPaste(paste, this.model);
    },
    show: function (buffer, options, onCancel) {
        this.buffer = buffer;
        this.options = options || {};

        this.onCancel = onCancel;

        this.pbv = this.makePaste();
        if (this.pbv.model.isTooLarge()) {
            this.errored = true;
            this.buffer.trigger('postError', {message: 'paste_too_large'});
        } else if (this.options.immediate) {
            delete this.options.message;
            this.savePastebin(this.options, this.buffer);
        } else {
            this.render();
            DialogView.prototype.show.call(this);
        }
    },
    render: function () {
        this.nameInput.val(this.options.name);
        
        this.pbv.render({editable: true});
        this.pbv.renderSyntaxSelect(this.nameInput);
        this.messageInput.val(this.options.message);

        this.pastebinSelect.append(this.pbv.select);

        this.pastebinWrapper.append(this.pbv.el);
        
        this.askContainer.toggle(!this.options.manual);
        
        this.askCheckbox.off('change');
        this.askCheckbox.prop('checked', this.model.shouldPromptPastebins());
        this.askCheckbox.on('change', _.bind(function (e) {
            e.preventDefault();
            var value = this.askCheckbox.prop('checked');
            this.model.setPastebinPrompts(value);
        }, this));

        var pbv = this.pbv;
        this.afterShow = _.bind(function () {
            if (this.options.contents) {
                this.nameInput.focus().select();
            } else {
                pbv.focusEditor();
            }
        }, this);
    }
});


module.exports = PastebinDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/pastebindialogview.js
// module id = ER68
// module chunks = 1